// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-user-scene-header .content-header {
  margin-bottom: 2rem;
}
.new-user-scene-header .content-header .left-data {
  flex-basis: 100%;
}
.new-user-scene-header .content-header h2,
.new-user-scene-header .content-header p {
  display: flex;
  align-items: center;
}
.new-user-scene-header .content-header .head-description {
  margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/NewUserScene/NewUserHeader/index.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AACI;EACE,gBAAA;AACN;AACI;;EAEE,aAAA;EACA,mBAAA;AACN;AACI;EACE,gBAAA;AACN","sourcesContent":[".new-user-scene-header {\n  .content-header {\n    margin-bottom: 2rem;\n    .left-data {\n      flex-basis: 100%;\n    }\n    h2,\n    p {\n      display: flex;\n      align-items: center;\n    }\n    .head-description {\n      margin-top: 1rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
